import { visit } from "unist-util-visit";
import type { Root } from "mdast";

/**
 * Turns `:::note` / `:::warning` container directives into tinted panels.
 *
 * The point is that an author never types HTML to get a callout. The portal
 * already has `tinted-warning` and `tinted-success` in custom.scss, so these
 * map onto existing house styling rather than inventing a second look.
 */
const VARIANTS: Record<string, string> = {
  note: "tinted-info",
  success: "tinted-success",
  warning: "tinted-warning",
};

interface DirectiveNode {
  type: string;
  name?: string;
  data?: {
    hName?: string;
    hProperties?: Record<string, unknown>;
  };
}

export function remarkCallouts() {
  return (tree: Root) => {
    visit(tree, (node) => {
      const directive = node as DirectiveNode;
      if (directive.type !== "containerDirective") return;

      const variant = VARIANTS[directive.name ?? ""];
      // An unrecognised directive is left alone rather than silently
      // swallowed — it will render as plain text, which is visible in review.
      if (!variant) return;

      directive.data = {
        ...directive.data,
        hName: "div",
        hProperties: {
          className: ["help-callout", variant, "rounded", "p-3", "mb-3"],
        },
      };
    });
  };
}
